(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.controller('UserCardController', ['$scope', 'UserService', 'Alert', '$filter', 'SharedAgendaService', 'Languages', '$rootScope', 'BackgroundJobState', 'WebsocketService', 'WebsocketRegisterType', UserCardControllerFn]);

    // controller for user card item
    function UserCardControllerFn($scope, UserService, Alert, $filter, SharedAgendaService, Languages, $rootScope, BackgroundJobState, WebsocketService, WebsocketRegisterType) {
        var vm = this;
        // contact infos to show ?
        vm.contactInfosToShow = false;
        vm.addressToShow = false;
        vm.languageBadgeText = '';
        vm.isAllowedToSeeSensitiveInfo = $rootScope.isAllowedToSeeSensitiveInfo;
        vm.ringphoneHqId = SharedAgendaService.getRingphoneHqId();
        vm.allowedToDeactivateAgenda = $rootScope.isRingfoonAdminOnly;
        vm.deactivationState = BackgroundJobState;

        activate();

        vm.isBeingDeactivated = () => {
            let state = vm.user.deactivationState;
            return !(state === BackgroundJobState.None.value || state === BackgroundJobState.Failed.value);
        };
        
        /* deactivate user */
        vm.deactivate = (user) => {
            UserService.showDeactivateUserById(user.id, SharedAgendaService.data.currentAgenda.id).then(function (result) {
                if (result === undefined) { return; }
                user.isDeactivated = true;
                Alert.translateSuccess(result);
            });
        };

        vm.activate = (user) => {
            UserService.updateActiveStateById(user.id, SharedAgendaService.data.currentAgenda.id, true).then((result) => {
                if (result) {
                    user.isDeactivated = false;
                    Alert.translateSuccess(result);
                }
            });
        };

        vm.deactivateMainUser = (user) => {
            UserService.showDeactivateMainUserById(user.id).then(function (result) {
                if (result === undefined) { return; }
                user.isBeingDeactivated = true;
                user.deactivationState = BackgroundJobState.Enqueued.value;
            });
        };

        // activation work
        function activate() {

            // does user have contact info to show ?
            if (vm.user.company !== null || vm.user.detail.hasNationalNumber || vm.user.medicalDiscipline !== null || vm.user.detail.street !== null || vm.user.detail.streetNumber !== null || vm.user.detail.zipCode !== null
                || vm.user.detail.location !== null || vm.user.detail.country !== null) {
                vm.addressToShow = true;
            }
            
            if (vm.user.languageId !== null) {
                switch (vm.user.languageId) {
                    case Languages.English.id: vm.languageBadgeText = Languages.English.iso; break;
                    case Languages.German.id: vm.languageBadgeText = Languages.German.iso; break;
                    case Languages.Dutch.id: vm.languageBadgeText = Languages.Dutch.iso; break;
                    case Languages.French.id: vm.languageBadgeText = Languages.French.iso; break;
                    default: vm.languageBadgeText = Languages.Unknown.iso; break;
                }
            }

            if (vm.user.contactInfos.length > 0) {
                vm.contactInfosToShow = true;
            }
            
            listen();
        }
        
        function listen() {
            var wsUserDeactivationStateUpdate = WebsocketService.register(WebsocketRegisterType.UserDeactivationStateUpdate, function (obj) {
                if (obj.data.userId === vm.user.id) {
                    let state = obj.data.state;
                    
                    if (state === vm.user.deactivationState) {
                        return;
                    }
                    
                    $scope.$apply(() => {
                        vm.user.deactivationState = state;
                    });

                    let message = `deactivation_state_${state}`;
                    if (state === BackgroundJobState.Failed.value)
                    {
                        Alert.error(message);
                        return;
                    }
                    
                    Alert.translateSuccess(message);
                }
            });
            
            $scope.$on("$destroy", function () {
                if (wsUserDeactivationStateUpdate) {
                    WebsocketService.unregister(wsUserDeactivationStateUpdate.id);
                }
            });
        }
    }
})();
